var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.verified)?_c('div',{staticClass:"block__loader"},[_c(_setup.Loader)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }